// @flow
import * as React from 'react'
import shallowEqual from 'mz-utils/shallowEqual'
import { FormattedMessage } from 'mz-intl'
import type { Flight } from 'mz-sdk/services/flights/getFlights'
import validateFlight from '../utils/validateFlight'
import Alert from '../../../core/Alert'
import { Container, Title, AccordingDatabase } from './elements'
import messages from '../messages.intl'

// Types
import type { FlightInfo } from '../BasicFlightField'

type Props = {
  flight: Flight,
  flightInfo: FlightInfo,
  searchId: ?string,
}
type State = {
  warning: *,
  loading: boolean,
}

class ValidateSelectedFlight extends React.Component<Props, State> {
  iteration = 0

  unmounted = false

  state = {
    warning: null,
    loading: false,
  }

  componentWillUnmount() {
    this.unmounted = true
  }

  componentDidMount() {
    this.validateFlight(this.props)
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (
      !shallowEqual(nextProps.flight, this.props.flight) ||
      !shallowEqual(nextProps.flightInfo, this.props.flightInfo) ||
      nextProps.searchId !== this.props.searchId
    ) {
      this.validateFlight(nextProps)
    }
  }

  async validateFlight(props: Props) {
    this.setState({ loading: true })
    const iteration = ++this.iteration
    const { flight, flightInfo, searchId } = props

    if (!searchId) {
      this.setState({ warning: null, loading: false })
    } else {
      const result = await validateFlight(flight, flightInfo, searchId)
      if (iteration === this.iteration && !this.unmounted) {
        this.setState({ warning: result, loading: false })
      }
    }
  }

  render() {
    const { warning, loading } = this.state
    if (!warning) return null

    return (
      <Container $loading={loading}>
        <Alert color="yellow">
          {warning.title && <Title>{warning.title}</Title>}
          <span dangerouslySetInnerHTML={{ __html: warning.message }} />
          <AccordingDatabase>
            <FormattedMessage message={messages.ACCORDING_OUR_DATABASE} />
          </AccordingDatabase>
        </Alert>
      </Container>
    )
  }
}

export default ValidateSelectedFlight
